import {
  AssignHostFamilyRequestInput,
  ChangeHostFamilyRequestInput,
  UnassignHostFamilyRequestInput
} from '../../lib/types/models/center/assign-host-family'
import { Center } from '../../lib/types/models/center/center'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const assignHostFamilyToStaff = (input: AssignHostFamilyRequestInput) => {
  const { centerId, id, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.centers.assignHostFamilyToStaff.url, {
        id: centerId,
        affectedStaffId: id
      })
    )
    .post<Center>({ ...rest })
}

export const unassignStaffHostFamily = (input: UnassignHostFamilyRequestInput) => {
  const { centerId, id, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.centers.unassignHostFamilyToStaff.url, {
        id: centerId,
        affectedStaffId: id
      })
    )
    .post(rest)
}

export const changeStaffHostFamily = (input: ChangeHostFamilyRequestInput) => {
  const { centerId, id, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.centers.changeStaffHostFamily.url, { id: centerId, affectedStaffId: id })
    )
    .post<Center>({ ...rest })
}
